import React from 'react';
import {motion} from "framer-motion";
import RoomDetailsOffcanvas from "./RoomDetailsOffcanvas";
import {Button, OverlayTrigger, Tooltip} from "react-bootstrap";
import {FaDoorClosed, FaEye, FaInfoCircle, FaUser} from "react-icons/all";
import {Trans, useTranslation} from "react-i18next";

const item = {
    hidden: {y: 20, opacity: 0},
    visible: {
        y: 0,
        opacity: 1
    }
};

const RoomItemComponent = ({ room, isInCart, addRoomToCart, openModal, type }) => {
    const isApartment = room.apartment === true;

    const { t } = useTranslation();

    return (
        <motion.div className="" variants={item}>
            <div className="card p-0 mb-4">
                <div className="row order-rl">

                    <RoomDetailsOffcanvas
                        room={room}
                        isInCart={isInCart(room.id)}
                        addRoom={() => addRoomToCart(room, type)}
                        addPlaces={() => addRoomToCart(room)}
                    />

                    <div className="col-xl-8">
                        <div className="row card-body h-100">
                            <div className="col-xl-8 card-title m-0 p-0">
                                <h4>{t(room.description)}</h4>
                                <div className="icons-inline">
                                    <OverlayTrigger
                                        placement="bottom"
                                        overlay={<Tooltip>{t("Liczba miejsc")}</Tooltip>}
                                    >
                                        <p>
                                            <FaUser/> {room.forHowManyPeople}
                                        </p>
                                    </OverlayTrigger>

                                    {/* 1. Ukrywamy wolne miejsca, jeśli to apartament */}
                                    {!isApartment && (
                                        <OverlayTrigger
                                            placement="bottom"
                                            overlay={<Tooltip>{t("Liczba wolnych miejsc")}</Tooltip>}
                                        >
                                            <p>
                                                <FaUser className="text-success"/> {room.placesLeft}
                                            </p>
                                        </OverlayTrigger>
                                    )}

                                    {/* 2. Ukrywamy numer pokoju, jeśli to apartament */}
                                    {!isApartment && (
                                        <OverlayTrigger
                                            placement="bottom"
                                            overlay={<Tooltip>{t("Numer pokoju")}</Tooltip>}
                                        >
                                            <p>
                                                <FaDoorClosed/> {room.roomNumber}
                                            </p>
                                        </OverlayTrigger>
                                    )}
                                </div>

                                <div className="mt-2">
                                    <p className="mb-1">
                                        <span className="link-primary cursor-pointer"
                                              onClick={() => openModal(room.imgUrl, room.description, room.id)}>
                                            <FaEye/> Sprawdź dostępność
                                        </span>
                                    </p>

                                    {/* 3. Warunkowa informacja o apartamencie lub wynajmie całości */}
                                    {isApartment ? (
                                        <p className="d-flex align-items-center">
                                            <FaInfoCircle/>
                                            <span className="fst-italic ms-2">
                                                {t("Apartament maksymalnie dla 4 osób")}
                                            </span>
                                        </p>
                                    ) : (
                                        (room.forHowManyPeople === room.placesLeft) && (
                                            <p className="d-flex align-items-center">
                                                <FaInfoCircle/>
                                                <span className="fst-italic ms-2">
                                                    <Trans i18nKey='RoomList_8'>Istnieje możliwość wynajęcia całego pokoju</Trans>
                                                </span>
                                            </p>
                                        )
                                    )}
                                </div>

                                <div className="row order-second text-nowrap mt-3">
                                    {/* 4. Ukrywamy przycisk "Wynajmij miejsca", jeśli to apartament */}
                                    {!isApartment && (
                                        <div className={isInCart(room.id) ? "d-none" : "mb-2 col"}>
                                            <Button variant="grad"
                                                    className="col-12"
                                                    size="lg"
                                                    disabled={(room.forHowManyPeople === 3) || (room.forHowManyPeople === 2) || (isInCart(room.id))}
                                                    onClick={() => addRoomToCart(room)}
                                            >
                                                <Trans i18nKey='RoomList_12'>Wynajmij miejsca</Trans>
                                            </Button>
                                        </div>
                                    )}

                                    <div className="col">
                                        <Button variant="grad"
                                                className="col-12 mb-2"
                                                size="lg"
                                            // Dla apartamentu przycisk jest aktywny, jeśli nie ma go w koszyku
                                                disabled={(isApartment ? false : room.forHowManyPeople !== room.placesLeft) || (isInCart(room.id))}
                                                onClick={() => addRoomToCart(room, type)}
                                        >
                                            {(isInCart(room.id)) ?
                                                <Trans i18nKey='RoomList_13'>W koszyku</Trans> :
                                                <Trans i18nKey='RoomList_11'>Wynajmij pokój</Trans>}
                                        </Button>
                                    </div>
                                </div>
                            </div>

                            <div className="col-xl-4 col text-nowrap d-flex justify-content-center align-items-center room-price desc-price">
                                <div className="mobile-price" title="Cena za noc">
                                    <p className="price-up">
                                        {room.pricePerPeron} zł <small>/ <Trans i18nKey='RoomList_14'>os.</Trans></small>
                                    </p>
                                    <p className="price-down">
                                        {room.pricePerPeron * room.forHowManyPeople} zł <small>/ <Trans i18nKey='RoomList_15'>łącznie</Trans></small>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </motion.div>
    );
};
export default RoomItemComponent;
